import type { IDecimalValueAndUnit, IDocument, IHaulageJob, IHaulageJobForm } from '@/interfaces'
import Base from '../Base'
import { type JobStatusType } from '@/enum'
import JobSiteInfo from '../JobSiteInfo'
import PriceWithUnit from '../PriceWithUnit'

class HaulageJobRequestForm extends Base implements IHaulageJobForm {
  status: JobStatusType
  description: string | null
  customerId: string | null
  wasteCollectionProviderId: string | null
  wasteCollectionSiteInfo: JobSiteInfo
  deliverySiteInfo: JobSiteInfo
  requestDate: string | null
  scheduleDate: string | null
  price: IDecimalValueAndUnit | null
  purchaseOrderDocuments: IDocument[]
  purchaseOrderNumber: string | null
  assignedEmployeeId: string | null
  assignedVehicleId: string | null
  assignedEquipmentId: string | null
  notes: string | null

  constructor(jobData?: IHaulageJob) {
    super(jobData)
    this.status = jobData?.status ?? 0
    this.description = jobData?.description ?? null
    this.customerId = jobData?.customerId ?? null
    this.wasteCollectionProviderId = jobData?.wasteCollectionProviderId ?? null
    this.wasteCollectionSiteInfo = jobData?.wasteCollectionSiteInfo ?? new JobSiteInfo()
    this.deliverySiteInfo = jobData?.deliverySiteInfo ?? new JobSiteInfo()
    this.requestDate = jobData?.requestDate ?? null
    this.scheduleDate = jobData?.scheduleDate ?? null
    this.price = new PriceWithUnit(jobData?.price)
    this.purchaseOrderDocuments = jobData?.purchaseOrderDocuments ?? []
    this.purchaseOrderNumber = jobData?.purchaseOrderNumber ?? null
    this.assignedEmployeeId = jobData?.assignedEmployeeId ?? null
    this.assignedVehicleId = jobData?.assignedVehicleId ?? null
    this.assignedEquipmentId = jobData?.assignedEquipmentId ?? null
    this.notes = jobData?.notes ?? null
  }
}

export default HaulageJobRequestForm
